import type { PageSection } from "./pageSection";

export type PageTypeDefinition = {
  key: string;
  name: string;
  description: string;
  hasSubmenu: boolean;
  sections?: PageSection[];
};

export const FRAGMENT_PAGE_TYPE = "fragment";

export const LANDING_PAGE_TYPE = "landing_page";

export const SIMPLE_PAGE_TYPE = "simple_page";

const PAGE_TYPE_REGISTRY: PageTypeDefinition[] = [
  {
    key: SIMPLE_PAGE_TYPE,
    name: "Simple page",
    description: "Just the page content, full width.",
    hasSubmenu: false,
  },
  {
    key: "page_with_submenu",
    name: "Page with sidebar",
    description: "Content plus a sidebar menu linking related pages, like About Us.",
    hasSubmenu: true,
  },
  {
    key: LANDING_PAGE_TYPE,
    name: "Landing page",
    description: "Full-width coloured sections with breadcrumbs, like the Data Products pages.",
    hasSubmenu: false,
    sections: ["data-products"],
  },
  {
    key: FRAGMENT_PAGE_TYPE,
    name: "Fragment",
    description: "A piece of content used inside another page, not a page of its own.",
    hasSubmenu: false,
  },
];

export function getPageTypes(): PageTypeDefinition[] {
  return PAGE_TYPE_REGISTRY;
}

export function getPageType(key: string): PageTypeDefinition | undefined {
  return PAGE_TYPE_REGISTRY.find(pt => pt.key === key);
}

function offeredInSection(pageType: PageTypeDefinition, section: PageSection): boolean {
  return pageType.sections === undefined || pageType.sections.includes(section);
}

export function isLayoutOfferedInSection(key: string, section: PageSection): boolean {
  const pageType = getPageType(key);
  return pageType === undefined || offeredInSection(pageType, section);
}

export function getLayoutOptions(currentType: string, section: PageSection): PageTypeDefinition[] {
  const options = PAGE_TYPE_REGISTRY.filter(
    pt =>
      pt.key === currentType || (pt.key !== FRAGMENT_PAGE_TYPE && offeredInSection(pt, section)),
  );
  if (currentType && !getPageType(currentType)) {
    options.push({
      key: currentType,
      name: currentType,
      description: "An older layout. It shows as a simple page on the site.",
      hasSubmenu: false,
    });
  }
  return options;
}
